<template>
<div>
  <div class="row mb-2" v-if="hasSearch">
    <div class="col-12">
      <slot></slot>
    </div>
    <div class="col-12">
      <div class="search-box me-2 mb-2 d-inline-block w-100">
        <div class="position-relative">
          <input type="text" class="form-control py-2" style="font-size: 20px" v-model="searchTerm" placeholder="Search..." />
          <i class="bx bx-search-alt search-icon pt-2" style="font-size: 20px" ></i>
        </div>
      </div>
    </div>
  </div>
  <vue-good-table
      :columns="columns" styleClass="vgt-table"
      :rows="rows"

      @on-search= "afterSearchFn"

      @on-selected-rows-change="selectionChangedFn"


      :pagination-options="{
        enabled: hasPagination,
        perPage: perPage,
        perPageDropdownEnabled: false,
      }"
      :search-options="{
        enabled: hasSearch,
        externalQuery: searchTerm,
      }"
      :select-options="{ enabled: hasSelect }"
  >
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field === 'actions'">
        <slot v-bind:row="props.row" name="actions"></slot>
      </span>
      <span v-else-if="props.column.field === 'due_by'">
        <date-is-today :current_date="props.row.due_by"/>
      </span>
      <span v-else-if="props.column.field === 'createdAt'">
        <span v-if="props.row.createdAt">
          <date-is-today :current_date="props.row.createdAt"/>
        </span>
      </span>
      <span v-else-if="props.column.field === 'dateOrdered'">
        <date-is-today :current_date="props.row.dateOrdered"/>
      </span>
      <span v-else-if="props.column.field === 'expiryDate'">
        <date-is-today :current_date="props.row.expiryDate"/>
      </span>
      <span v-else-if="props.column.field === 'deliveryDate'">
        <date-is-today :current_date="props.row.deliveryDate"/>
      </span>
      <span v-else-if="props.column.field === 'paymentReceivedDate'">
        <date-is-today :current_date="props.row.paymentReceivedDate"/>
      </span>
      <span v-else-if="props.column.field === 'visitDate'">
        <date-is-today :current_date="props.row.visitDate"/>
      </span>
      <span v-else-if="props.column.field === 'paymentDueDate'">
        <date-is-today :current_date="props.row.paymentDueDate"/>
      </span>
      <span v-else-if="props.column.field === 'statementDeliveryDate'">
        <date-is-today :current_date="props.row.order.deliveryDate"/>
      </span>
      <span v-else-if="props.column.field === 'statementPaymentDue'">
        <date-is-today :current_date="props.row.order.paymentDueDate"/>
      </span>
      <span v-else-if="props.column.field === 'emailDeliveryDatetime'">
        {{ getDateTime(props.row.emailDeliveryDatetime) }}
      </span>
      <span v-else-if="props.column.field === 'due_status'">
<!--        <date-is-before-today :current_date="props.row.payment_due_date"/>-->
        <span v-if="props.row.isPaymentOverdue === false" class="badge rounded-pill font-size-11 badge-soft-warning mr-1">Due</span>
        <span v-else class="badge rounded-pill font-size-11 badge-soft-info mr-1">Not Due</span>
      </span>
      <span v-else-if="props.column.field === 'orderStatus'">
        <span v-if="props.row.status">
          <order-status-component :order_status="props.row.status.orderStatusName"/>
        </span>
      </span>
      <span v-else-if="props.column.field === 'item_status'">
        <order-status-component :order_status="props.row.item_status"/>
      </span>
      <span v-else-if="props.column.field === 'emailDeliveryStatus'">
        <span v-if="props.row.emailDeliveryStatus === '1'" class="badge rounded-pill font-size-11 badge-soft-success">True</span>
        <span v-else class="badge rounded-pill font-size-11 badge-soft-dark">False</span>
      </span>
      <span v-else-if="props.column.field === 'paymentStatus'">
        <payment-status-component :payment_status="props.row.paymentStatus.name"/>
      </span>
      <span v-else-if="props.column.field === 'paymentDetails'">
        <span v-if="props.row.paymentDetails">
          {{props.row.paymentDetails.paymentType.paymentMethodName}}
        </span>
      </span>
      <span v-else-if="props.column.field === 'current_status'">
        <span class="badge rounded-pill font-size-11 badge-soft-primary">{{props.row.current_status}}</span>
      </span>
      <span v-else-if="props.column.field === 'demo'">
        <span v-if="props.row.demo === false" class="badge rounded-pill font-size-11 badge-soft-dark">False</span>
        <span v-else class="badge rounded-pill font-size-11 badge-soft-info">True</span>
      </span>
      <span v-else-if="props.column.field === 'active_status'">
        <span v-if="props.row.active_status.toLowerCase() === 'active'" class="badge rounded-pill font-size-11 badge-soft-primary">{{props.row.active_status}}</span>
        <span v-else class="badge rounded-pill font-size-11 badge-soft-dark">{{props.row.active_status}}</span>
      </span>
      <span v-else-if="props.column.field === 'activeState'">
        <span v-if="props.row.activeState === true" class="badge rounded-pill font-size-11 badge-soft-primary">Active</span>
        <span v-else class="badge rounded-pill font-size-11 badge-soft-dark">Inactive/Closed</span>
      </span>
      <span v-else-if="props.column.field === 'isActive'">
        <span v-if="props.row.isActive === true" class="badge rounded-pill font-size-11 badge-soft-primary">Active</span>
        <span v-else class="badge rounded-pill font-size-11 badge-soft-dark">Inactive</span>
      </span>
      <span v-else-if="props.column.field === 'statementGenDate'">
        <span v-if="props.row.statementGenDate !== null" class="badge rounded-pill font-size-11 badge-soft-primary">{{props.row.statementGenDate}}</span>
        <span v-else>N/A</span>
      </span>
      <span v-else-if="props.column.field === 'weekday'">
        <span v-for="day in props.row.weekday" :key="day.weekday_public_id">
          <span class="badge rounded-pill font-size-11 badge-soft-info mx-1">{{day}}</span>
        </span>
      </span>
      <span v-else-if="props.column.field === 'permissions'">
        <span v-for="permission in props.row.permissions" :key="permission.id">
          <span class="badge rounded-pill font-size-11 badge-soft-info mx-1">{{permission.name}}</span>
        </span>
      </span>
      <span v-else-if="props.column.field === 'customerTier'">
        {{props.row.typeId.tier.name}}
      </span>
      <span v-else-if="props.column.field === 'typeId'">
        {{props.row.typeId.name}}
      </span>
      <span v-else-if="props.column.field === 'tier'">
        {{props.row.tier.name}}
      </span>
      <span v-else-if="props.column.field === 'status'">
        <order-status-component :order_status="props.row.status.orderStatusName"/>
      </span>
      <span v-else-if="props.column.field === 'days'">
        <span v-for="day in props.row.days" :key="day.id">
          <span class="badge rounded-pill font-size-11 badge-soft-info mx-1">{{day.deliveryDay.weekday}}</span>
        </span>
      </span>
      <span v-else-if="props.column.field === 'zone'">
        {{props.row.zone.name}}
      </span>
      <span v-else-if="props.column.field === 'warehouseId'">
        <span v-if="props.row.warehouseId">
          {{props.row.warehouseId.name}}
        </span>
      </span>
      <span v-else-if="props.column.field === 'productId'">
        <span v-if="props.row.productId">
          {{props.row.productId.productName}}
        </span>
      </span>
      <span v-else-if="props.column.field === 'turnoverProductName'">
        <span v-if="props.row.productCode">{{props.row.productCode.productName}}</span>
      </span>
      <span v-else-if="props.column.field === 'productCode'">
        <span v-if="props.row.productId">
          {{props.row.productId.code}}
        </span>
      </span>
      <span v-else-if="props.column.field === 'salesType'">
        {{props.row.salesType.name}}
      </span>
      <span v-else-if="props.column.field === 'staff'">
        {{props.row.staff.name}}
      </span>
      <span v-else-if="props.column.field === 'currentStatus'">
        <span v-if="props.row.currentStatus">{{props.row.currentStatus.status.name}}</span>
      </span>
      <span v-else-if="props.column.field === 'salesCustomer'">
        <span v-if="props.row.customer"> {{props.row.customer.name}}</span>
      </span>
      <span v-else-if="props.column.field === 'lastUpdatedBy'">
        <span v-if="props.row.lastUpdatedBy">
          {{props.row.lastUpdatedBy.name}}
        </span>
      </span>
      <span v-else-if="props.column.field === 'newOwner'">
        {{props.row.userId.name}}
      </span>
      <span v-else-if="props.column.field === 'orderCustomerCode'">
        {{props.row.customer.customerCode}}
      </span>
      <span v-else-if="props.column.field === 'dashboardCustomer'">
        {{props.row.order.customer.name}}
      </span>
      <span v-else-if="props.column.field === 'dashboardOrder'">
        {{props.row.order.invoiceId}}
      </span>
      <span v-else-if="props.column.field === 'dashboardOrderDate'">
        <span v-if="props.row.order.createdAt">
          <date-is-today :current_date="props.row.order.createdAt"/>
        </span>
      </span>
      <span v-else-if="props.column.field === 'dashboardDeliveryDate'">
        {{props.row.order.deliveryDate}}
      </span>
      <span v-else-if="props.column.field === 'dashboardOrderTotal'">
        Ksh {{props.row.order.grossOrderTotal | formatNumber}}
      </span>

      <span v-else-if="props.column.field === 'dashboardPaymentDetails'">
        <span v-if="props.row.paymentType">
          {{props.row.paymentType.paymentMethodName}}
        </span>
      </span>
      <span v-else-if="props.column.field === 'dashboardOrderStatus'">
        <order-status-component :order_status="props.row.order.status.orderStatusName"/>
      </span>
      <span v-else-if="props.column.field === 'orderTimeZone'">
        <span v-if="props.row.timezone">{{props.row.timezone.timezoneName}}</span>
      </span>
      <span v-else-if="props.column.field === 'orderCustomer'">
        {{props.row.customer.institutionId.name}}
      </span>
      <span v-else-if="props.column.field === 'statementCustomer'">
        {{props.row.customerId.name}}
      </span>
      <span v-else-if="props.column.field === 'statementInvoice'">
        {{props.row.order.invoiceId}}
      </span>
      <span v-else-if="props.column.field === 'statementOrderBy'">
        {{props.row.order.orderedBy}}
      </span>
      <span v-else-if="props.column.field === 'statementTotal'">
        Ksh {{props.row.order.grossOrderTotal | formatNumber}}
      </span>
      <span v-else-if="props.column.field === 'feedbackOwner'">
        <span v-if="props.row.feedbackOwner">{{props.row.feedbackOwner.name}}</span>
      </span>
      <span v-else-if="props.column.field === 'lastUpdatedByDate'">
        <span v-if="props.row.lastUpdatedBy">
          <date-is-today :current_date="props.row.lastUpdatedBy.updatedAt"/>
        </span>
      </span>
      <span v-else-if="props.column.field === 'productCount'">
        <span v-if="props.row.orderItems">
          {{props.row.orderItems.length}}
        </span>
      </span>
      <span v-else-if="props.column.field === 'grossOrderTotal'">
        Ksh {{props.row.grossOrderTotal | formatNumber}}
      </span>
      <span v-else-if="props.column.field === 'orderBalanceDue'">
        Ksh {{props.row.orderBalanceDue | formatNumber}}
      </span>
      <span v-else-if="props.column.field === 'orderTotal'">
        Ksh {{props.row.orderTotal | formatNumber}}
      </span>
      <span v-else-if="props.column.field === 'orderPrice'">
        Ksh {{props.row.orderPrice | formatNumber}}
      </span>
      <span v-else-if="props.column.field === 'quantity'">
        {{props.row.quantity | formatNumberWithoutDecimal}}
      </span>
      <span v-else-if="props.column.field === 'initialStockQuantity'">
        {{props.row.initialStockQuantity | formatNumberWithoutDecimal}}
      </span>
      <span v-else-if="props.column.field === 'newStockQuantity'">
        {{props.row.newStockQuantity | formatNumberWithoutDecimal}}
      </span>
      <span v-else-if="props.column.field === 'quantityCase'">
        {{props.row.quantityCase | formatNumberWithoutDecimal}}
      </span>
      <span v-else-if="props.column.field === 'quantityBall'">
        {{props.row.quantityBall | formatNumberWithoutDecimal}}
      </span>
      <span v-else-if="props.column.field === 'quantityPiece'">
        {{props.row.quantityPiece | formatNumberWithoutDecimal}}
      </span>
      <span v-else-if="props.column.field === 'deliveryDay'">
        <span class="badge rounded-pill font-size-11 badge-soft-info mx-1">{{props.row.deliveryDay.weekday}}</span>
      </span>
      <span v-else-if="props.column.field === 'productOrderAvailability'">
        <slot v-bind:row="props.row" name="productOrderAvailability"></slot>
      </span>
      <span v-else>
        {{props.formattedRow[props.column.field]}}
      </span>
    </template>
  </vue-good-table>

</div>
</template>

<script>
import OrderStatusComponent from "@/components/orders/order-status-component";
import DateIsToday from "@/components/orders/date-is-today";
import PaymentStatusComponent from "@/components/finance/payment-status-component";
import moment from 'moment'
export default {
  name: "data-table",
  components: {PaymentStatusComponent, DateIsToday, OrderStatusComponent},
  data(){
    return{
      searchTerm: ''
    }
  },
  props: {
    hasSearch: {type: Boolean, default: true},
    hasPagination: {type: Boolean, default: true},
    hasSelect: {type: Boolean, default: false},
    rows: {type: Array},
    columns: {type: Array},
    perPage: {type: Number, default: 30},
    currentPage: {type: Number, default: 1}
  },
  methods: {
    afterSearchFn(params){
      setTimeout(() =>{
        this.$emit('onSearch', this.searchTerm)
      }, 1000)

      if (params.searchTerm){
        this.routeChangeQuery(this.searchTerm, this.currentPage)
      }
    },
    selectionChangedFn(params){
      if (params.selectedRows.length > 0){
        this.$emit('selectFn', params.selectedRows)
      }

    },
    getDateTime(date){
      return moment(date).format('LLL')
    },
    routeChangeQuery(search, page){
      this.$router.push({query: {keyword: search, page: page}}).catch(() => {})
    }
  },
  beforeMount() {
    this.searchTerm = this.$route.query.keyword || ""
  },
  watch: {
    currentPage(){
      this.routeChangeQuery(this.searchTerm, this.currentPage)
    }
  }
}
</script>

<style scoped>

</style>
